export const transactionStatusTypes = {
  Unknown: 'Unknown',
  Completed: 'Booked', //Means transaction is fully utilized and every responsibility is finished (e.g. CheckedOut)
  InUse: 'Active', //Consumer is now consuming the product or services
  NoShow: 'No show', //Not cancelled but not used as well
  Cancelled: 'Cancelled', //Cancelled before consumption started
  Confirmed: 'Confirmed', //Consumer ordered the product or services (for product deliveries, this can be very quickly completed as well)
  WaitListed: 'Waiting', //Either back order or fully booked service, waiting
  RefundPending: 'Pending refund'
}
